module.exports = __webpack_public_path__ + "img/3-vidio.6f813878.jpg";